// Resolved at build time via craco webpack alias (see craco.config.js).
// eslint-disable-next-line import/no-unresolved
import config from 'hippo-root-config';

export default {
  ...config,
  PARSE_INT_BASE: 10,
  CHART_RESOLUTION_MS: 1000,
  STALE_DATA_MS: 15000,
};
